import { memo, useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { Form, FormInput } from 'shards-react';
import { updateFilterByEnvelopeName } from 'utils/redux/actions';

const FilterByEnvelopeName = ({ dispatch, filterByEnvelopeName = '' }) => {
	const [inputValue, setInputValue] = useState(() => filterByEnvelopeName);

	const changeHandler = useCallback(
		({ target }) => {
			const { value } = target;
			const { valueMissing } = target.validity;

			if (valueMissing) dispatch(updateFilterByEnvelopeName(value));

			return setInputValue(value);
		},
		[dispatch]
	);

	const handleSubmit = useCallback(
		(e) => {
			e.preventDefault();

			console.log("handleSubmit", inputValue);

			dispatch(updateFilterByEnvelopeName(inputValue));
		},
		[inputValue, dispatch]
	);

	return (
		<Form onSubmit={handleSubmit}>
			<FormInput required type='search' spellCheck='false' autoComplete='false' value={inputValue} onChange={changeHandler} placeholder='Nach Name der Mappe filtern' />
		</Form>
	);
};

const mapStateToProps = ({ filterByEnvelopeName }) => ({ filterByEnvelopeName });

export default connect(mapStateToProps)(memo(FilterByEnvelopeName));
